export default {
  maxCltv: 0.85,
  maxCltvSecondHome: 0.75,
  maxCltvInvestment: 0.65,
};
